import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import useKeyboardShortcutBlocker from "./KeyboardShortcutBlocker";
import { useNavigate, Link } from "react-router-dom";
import { Headernew } from "./Headernew";
import { FaStar } from "react-icons/fa";
import Slider from "react-slick";
import "./assets/banner/scss/defult.css";
import "./assets/banner/scss/main.css";
export const Banner24 = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  //useKeyboardShortcutBlocker();

  const audioRef = useRef(null); // Ref for the audio element

  // Function to handle user input changes

  // Function to start recording audio

  // Function to stop recording audio
  const [checklogin, setchecklogin] = useState(false);
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    const userStr = JSON.parse(localStorage.getItem("users"));
    document.title = "Jlmining Page";
    if (userStr !== null) {
      setchecklogin(true);
      navigate("/home");
    }
  }, [checklogin]);
  var settings_2 = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  };

  var settings_3 = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1020,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Headernew />
      <section className="d-block main_banner py-5">
        <div className="container-xl h-100">
          <div className="d-flex h-100 justify-content-center  align-items-center">
            <div className="banner_text">
              <h1>
                Built for Opportunity
                <br />
                Your Next Job, Crew or Contract Starts Here
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block py-5 client">
        <div className="container-xl">
          <div className="row gy-4 align-items-end">
            <div className="col-lg-4">
              <div className="px-lg-4">
                <div className="d-flex flex-column gap-3 justify-content-center align-items-center client_box">
                  <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
                    <div className="d-block icon_social">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/banner/images/icon1.png")}
                        alt="images"
                      />
                    </div>
                    <h3>JOB OPPORTUNITY</h3>
                  </div>
                  <p>
                    Create your profile in our recruitment database for
                    exclusive access to potential job opportunities.
                  </p>
                  <a className="join_btn" href="/register">
                    Join the wait List
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-4 justify-content-center align-items-center client_box mid_client">
                <div className="d-flex flex-column gap-3 justify-content-center align-items-center">
                  <div className="d-block icon_social">
                    <img
                      className="w-100 h-100"
                      src={require("./assets/banner/images/icon3.png")}
                      alt="images"
                    />
                  </div>
                  <h3>FIND YOUR CREW</h3>
                </div>
                <p>
                  Explore our services to discover how JL Mining can support
                  your future recruitment needs.
                </p>
                <a href="client/" className="join_btn">
                  View our Services
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="px-lg-4">
                <div
                  className="d-flex flex-column gap-3 justify-content-center align-items-center client_box"
                  style={{ height: "325px" }}
                >
                  <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
                    <div className="d-block icon_social">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/banner/images/icon2.png")}
                        alt="images"
                      />
                    </div>
                    <h3>SUB CONTRACTOR</h3>
                  </div>
                  <p>Explore how we take care of our Trusted Subbies </p>
                  <a className="join_btn" href="login/">
                    Explore
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block about_us_home pt-5">
        <div className="container-xl">
          <div className="row gy-3">
            <div className="col-lg-6 ">
              <div className="d-flex flex-column gap-4">
                <h4>About us</h4>
                <h6>
                  At JL Mining, we are more than just a workforce provider.
                </h6>
                <p>
                  we’re the connection point between skilled tradespeople,
                  top-tier mining clients, and reliable subcontractors across
                  Australia.
                </p>
                <button className="home_globalbtn">
                  Learn more{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right-dashed"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M5 12h.5m3 0h1.5m3 0h6" />
                    <path d="M13 18l6 -6" />
                    <path d="M13 6l6 6" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="col-lg-6 pt-4">
              <div className="d-block icon_social">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/home_24.png")}
                  alt="images"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="d-block py-5 proven">
        <div className="container-xl">
          <div className="row">
            <div className="col-lg-3 d-md-block d-none">
              <div className="d-block pro_img1">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/home3.png")}
                  alt="images"
                />
              </div>
            </div>
            <div className="col-lg-7 px-md-5 pt-md-5 ">
              <div className="d-flex flex-column gap-4">
                <h5>Proven Capability. Local Strength. Growing Impact.</h5>
                <div className="d-flex flex-column gap-3">
                  <p>
                    JL Mining is a proudly Australian company delivering
                    reliable maintenance, labour hire, and electrical solutions
                    to the mining and civil construction industries. With
                    boots-on-the-ground experience and a commitment to safety
                    and service, we’ve earned a reputation for getting the job
                    done on time, every time.
                  </p>
                  <p>
                    As we grow, so does our reach, supporting more clients,
                    employing skilled professionals, and powering more projects
                    across the state.
                  </p>
                </div>
                <button className="home_globalbtn">
                  Learn more about our journey and what drives us:
                </button>
                <div className="row gy-4">
                  <div className="col-lg-3">
                    <div className="d-flex flex-column gap-1">
                      <h6>20+</h6>
                      <p>years of industry experience</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="d-flex flex-column gap-1">
                      <h6>100+</h6>
                      <p>successful mining & civil projects</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="d-flex flex-column gap-1">
                      <h6>2</h6>
                      <p>strategic WA locationsEast Bunbury & Henderson</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="d-flex flex-column gap-1">
                      <h6>24/7 </h6>
                      <p>mobile field service & rapid response team</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 d-md-block d-none">
              <div className="d-block pro_img2">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/home4.png")}
                  alt="images"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="safety_drives d-block pb-5">
        <div className="container-xl">
          <div className="row gy-4">
            <div className="col-12">
              <div className="d-block bn_mg ">
                <img
                  className="w-100 h-100 d-md-block d-none"
                  src={require("./assets/images/home5.png")}
                  alt="images"
                />
                <h5>
                  Safety Drives <br /> Everything We Do
                </h5>
              </div>
            </div>
            <div className="col-lg-6 col-lg-7 mx-auto ps-lg-5">
              <div className="d-flex flex-column gap-4">
                <h5>
                  At JL Mining, health and safety isn’t just a box to tick
                </h5>
                <div className="d-flex flex-column gap-3">
                  <p>
                    it’s the foundation of every job we take on. Our hands-on
                    experience in mining maintenance and electrical works is
                    backed by a deep commitment to occupational health and
                    safety, risk management, and industry compliance.
                  </p>
                  <p>
                    We invest in certified training, up-to-date equipment, and
                    well-defined systems to ensure that every team member and
                    every worksite meets the highest safety standards. The
                    result? Fewer delays, better outcomes, and a safer, more
                    productive future for everyone involved
                  </p>
                </div>
                <button className="home_globalbtn">
                  Learn more about our safety-first approach and standards
                </button>
                <h5 className="pt-5 text-center">Our Services</h5>
                <h6 className="text-center">
                  Two Divisions. One Mission Keeping Your Operations Running at
                  Full Capacity.
                </h6>
                <div className="row gy-3">
                  <div className="col-lg-4">
                    <div className="d-flex flex-column gap-1">
                      <h6>JL Mining </h6>
                      <p>
                        handles heavy machinery maintenance, inspections, and
                        replacements.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="d-flex flex-column gap-1">
                      <h6>JL Mining Electrica </h6>
                      <p>
                        powers your site with high-voltage expertise and
                        underground capability.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="d-flex flex-column gap-1">
                      <h6>Fast. Reliable. Safe. </h6>
                      <p>
                        From urgent deliveries to on-site support — we’ve got
                        you covered, 24/7
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="d-block pb-5 sec_auto">
        <div className="container-xl">
          <div className="row gy-4">
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban4.jpg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>AUTOMOTIVE ELECTRICIANS</h5>
                  <p>
                    Our automotive electricians will keep your vital mining and
                    civil engineering equipment running efficiently.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg ">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban1.jpeg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>SHIFT ELECTRICIANS </h5>
                  <p>
                    Our team includes shift electricians with the training and
                    growing experience to handle shift work for all your civil,
                    commercial and industrial projects.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban2.jpeg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>HYDRAULIC FITTERS </h5>
                  <p>
                    Our mechanics know how to inspect, repair and replace
                    critical components in your hydraulic systems. Don t let an
                    important piece of heavy machinery sit idly by.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban3.jpg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>CIVIL ENGINEERING</h5>
                  <p>
                    Our civil construction personnel can dig trenches, conduits
                    and trenches. We also regrade and level construction
                    surfaces for your road systems and industrial operations
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban5.jpg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>CRANE OPERATORS</h5>
                  <p>
                    A vital part of our civil construction division includes
                    crane operation and our personnel are ready to help load and
                    offload materials and heavy equipment for any operation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-0 h-100">
                <div className="d-block sec_autoimg">
                  <img
                    className="w-100 h-100 object-fit-cover"
                    src={require("./assets/images/ban6.jpg")}
                    alt="images"
                  />
                </div>
                <div className="sec_autoinfo d-flex flex-column gap-2 h-100">
                  <h5>LIGHT VEHICLE FITTERS </h5>
                  <p>
                    Our light vehicle fitters are standing by to help keep your
                    fleet of important cars, trucks and vans running their best
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="d-block pb-5 past_client">
        <div className="container-xl">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="past_left h-100">
                <div className="d-flex h-100 flex-column z-3 rel gap-4 justify-content-center align-items-start ">
                  <h3>
                    PAST AND <br />{" "}
                    <span className="ps-3"> PRESENT CLIENTS</span>
                  </h3>
                  <div className="d-flex flex-column gap-3">
                    <p>
                      JL Holdings serves clients from a variety of mining and
                      industrial sectors across the whole of Western Australia.
                    </p>
                    <p>
                      Our clients include Tier-1 mining and industrial
                      engineering companies, their subcontractors and the
                      industries that serve them.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <table>
                <tbody>
                  <tr>
                    <td className="borderhl borderht">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l1.jpg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderht">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l2.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderht borderhr">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l3.jpg")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="borderhl">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-cover"
                          src={require("./assets/images/l4.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l5.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l6.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="borderhl">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l7.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l9.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr">
                      {" "}
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l10.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="borderhl">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l11.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l12.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr">
                      {" "}
                      <div className="d-block logo_client ">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l13.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="borderhl">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l14.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l15.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr">
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l16.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="borderhl borderhb">
                      {" "}
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l17.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhb">
                      {" "}
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l18.jpeg")}
                          alt="images"
                        />
                      </div>
                    </td>
                    <td className="borderhr borderhb">
                      {" "}
                      <div className="d-block logo_client">
                        <img
                          className="w-100 h-100 object-fit-contain"
                          src={require("./assets/images/l8.png")}
                          alt="images"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section className="d-block gallery py-5">
        <div className="container-xl">
          <div className="d-flex flex-column gap-5">
            <h4>Gallary</h4>

            <div class="gallery_parent">
              <div class="gallery_div1">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary1.jpeg")}
                  alt="images"
                />
              </div>
              <div class="gallery_div2">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary2.JPG")}
                  alt="images"
                />
              </div>
              <div class="gallery_div3">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary3.jpeg")}
                  alt="images"
                />
              </div>
              <div class="gallery_div4">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary4.jpeg")}
                  alt="images"
                />
              </div>
              <div class="gallery_div5">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary5.jpeg")}
                  alt="images"
                />
              </div>
              <div class="gallery_div6">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("./assets/images/gallary6.jpeg")}
                  alt="images"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="d-block testimonal pb-5">
        <div className="container-xl">
          <div className="d-flex flex-column gap-4">
            <h4>What our Clients and Employees Say</h4>
            <Slider {...settings_3} className="slider_testimonal">
              <div className="testimonal_box d-flex  flex-column gap-5">
                <div className="d-flex align-items-start flex-md-row flex-column gap-3">
                  <div className="profile_user">
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={require("./assets/images/ban6.jpg")}
                      alt="images"
                    />
                  </div>
                  <div className="d-flex flex-column gap-0">
                    <h5>Mathias Gwadanican</h5>
                    <p>
                      {" "}
                      <span>Partner, Sinouve SCOP</span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-1 star">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>
                <p>
                  Our clients include Tier-1 mining and industrial engineering
                  companies, their subcontractors and the industries that serve
                  them.{" "}
                </p>
              </div>
              <div className="testimonal_box d-flex  flex-column gap-5">
                <div className="d-flex align-items-start flex-md-row flex-column gap-3">
                  <div className="profile_user">
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={require("./assets/images/ban6.jpg")}
                      alt="images"
                    />
                  </div>
                  <div className="d-flex flex-column gap-0">
                    <h5>Mathias Gwadanican</h5>
                    <p>
                      {" "}
                      <span>Partner, Sinouve SCOP</span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-1 star">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>
                <p>
                  Our clients include Tier-1 mining and industrial engineering
                  companies, their subcontractors and the industries that serve
                  them.{" "}
                </p>
              </div>
              <div className="testimonal_box d-flex  flex-column gap-5">
                <div className="d-flex align-items-start flex-md-row flex-column gap-3">
                  <div className="profile_user">
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={require("./assets/images/ban6.jpg")}
                      alt="images"
                    />
                  </div>
                  <div className="d-flex flex-column gap-0">
                    <h5>Mathias Gwadanican</h5>
                    <p>
                      {" "}
                      <span>Partner, Sinouve SCOP</span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-1 star">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>
                <p>
                  Our clients include Tier-1 mining and industrial engineering
                  companies, their subcontractors and the industries that serve
                  them.{" "}
                </p>
              </div>
              <div className="testimonal_box d-flex  flex-column gap-5">
                <div className="d-flex align-items-start flex-md-row flex-column gap-3">
                  <div className="profile_user">
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={require("./assets/images/ban6.jpg")}
                      alt="images"
                    />
                  </div>
                  <div className="d-flex flex-column gap-0">
                    <h5>Mathias Gwadanican</h5>
                    <p>
                      {" "}
                      <span>Partner, Sinouve SCOP</span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-1 star">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>
                <p>
                  Our clients include Tier-1 mining and industrial engineering
                  companies, their subcontractors and the industries that serve
                  them.{" "}
                </p>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="d-block pb-5 our-partner">
        <div className="container-xl overflow-hidden">
          <div className="d-flex flex-column gap-2 pb-3">
            <h4>Our Trusted Partners</h4>
            <p>
              We deliver great results and we have cultivated long-term
              relationships with leading brands and companies.
            </p>
          </div>
          <Slider {...settings_2} className="logo-slider ">
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hss.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-bird.webp")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/jl-logo.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hunta.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img-h d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-minotaur.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-walc.png")}
                alt="logo"
              />
            </div>
          </Slider>
        </div>
      </section>

      <footer>
        <div className="ft-topbox d-block py-5">
          <div className="container-lg">
            <div className="row gy-4">
              <div className="col-lg-3">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>Contact us</h3>
                  <div className="d-flex flex-column gap-2 ft-links">
                    <p>Address: 8 Sparks Rd, Henderson WA 6166 </p>
                    <p>
                      <Link to="javascript:void(0)">Phone: +61 894375388</Link>{" "}
                    </p>
                    <p>Hours: 7:00am - 5:00pm Monday - Friday </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>Help</h3>
                  <div className="row gy-4">
                    <div className="col-lg-6">
                      <div className="d-flex flex-column gap-2 ft-links">
                        <p>
                          <Link to="/contact">Contact Information</Link>{" "}
                        </p>
                        <p>
                          <Link to="javascript:void(0)">How to Use</Link>{" "}
                        </p>
                        <p>
                          <Link to="/experthelp">Get Expert Help</Link>{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex flex-column gap-2 ft-links">
                        <p>
                          <Link to="/terms&condition">
                            Terms and Conditions
                          </Link>{" "}
                        </p>
                        <p>
                          <Link to="/privacypolicy">Privacy Policy</Link>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>exprole us</h3>
                  <div className="d-flex flex-column gap-2 ft-links">
                    <p>
                      <Link to="https://www.hssonline.com.au" target="_blank">
                        www.hssonline.com.au
                      </Link>{" "}
                    </p>
                    <p>
                      <Link to="https://www.hssptyltd.com.au" target="_blank">
                        www.hssptyltd.com.au
                      </Link>{" "}
                    </p>
                    <p>
                      <Link to="https://www.jlme.com.au" target="_blank">
                        www.jlme.com.au{" "}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copy-ft py-2 text-center">
          <div className="container-lg">
            <p>
              Privacy | Site Terms | &copy; {currentYear}, JL Mining All rights
              reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
